import React, { useState, useEffect } from "react";
import {
  fetchPaymentHistory,
  fetchUserBalance,
  topUpBalance,
} from "../../../services/api";
import TableDatagrid from "../../../components/TableDatagrid/TableDatagrid";
import CurrentBalance from "../../../components/Cards/CurrentBalance";
import colors from "../../../theme";
import SnackbarComp from "../../../components/Snackbar/SnackbarComp";

import { Box, Button, CircularProgress, Chip } from "@mui/material";
import Loader from "../../../components/Loader/Loader";

const PaymentsHistory = () => {
  const [currentUserBalance, setCurrentUserBalance] = useState(0);
  const [transactionsData, setTransactionData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isTopupLoading, setTopupLoading] = useState(false);

  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  useEffect(() => {
    getCurrentBalance();
    getPaymentHistory();

    const timerId = setTimeout(() => {
      getCurrentBalance();
    }, 5000);

    return () => clearTimeout(timerId);
  }, []);

  const getCurrentBalance = async () => {
    try {
      const data = await fetchUserBalance();
      if (data) {
        setCurrentUserBalance(data);
      }
    } catch (error) {
      console.error("Error fetching card details:", error);
    }
  };

  const getPaymentHistory = async () => {
    try {
      const response = await fetchPaymentHistory();
      if (response) {
        setTransactionData(response);
      }
    } catch (error) {
      console.error("Error fetching Payment history:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handletopUp = async () => {
    setTopupLoading(true);
    try {
      const response = await topUpBalance();
      setError(response.data.message);
      setStatusCode(response?.status || 500);
      setOpenSnackbar(true);
      getCurrentBalance();
    } catch (error) {
      setOpenSnackbar(true);
      setStatusCode(error.status);
      setError(error.message);
    } finally {
      getPaymentHistory();
      setTopupLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      headerClassName: "data-grid-header",
      flex: 0.3,
    },
    {
      field: "timestamp",
      headerName: "Date",
      flex: 1.2,
      headerClassName: "data-grid-header",
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 0.7,
      headerClassName: "data-grid-header",
      renderCell: (params) => {
        const isNegative = params.value < 0;
        return (
          <Box
            sx={{
              color: isNegative ? "red" : "green",
              fontWeight: "bold",
            }}
          >
            {isNegative ? params.value : `\u00A0${params.value}`}
          </Box>
        );
      },
    },
    {
      field: "paymentSuccess",
      headerName: "Success",
      flex: 0.7,
      headerClassName: "data-grid-header",
      renderCell: (params) =>
        params.value ? (
          <Chip size="small" label="✔" color="success" variant="outlined" />
        ) : (
          <Chip size="small" label="✘" color="error" variant="outlined" />
        ),
    },
  ];

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Box component="main" sx={{ flex: 1, py: 2, px: 2, bgcolor: "#eaeff1" }}>
        <CurrentBalance currentUserBalance={currentUserBalance} />
        {currentUserBalance <= 0 && (
          <Box
            sx={{
              backgroundColor: colors.mainContentBgColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              onClick={handletopUp}
              sx={{
                backgroundColor: colors.secondary,
                height: "5vh",
                width: { xs: "90vw", md: "15vw" },
                mb: "20px",
                color: "white",
                "&:hover": {
                  backgroundColor: colors.btnBackgroundColorOnHover,
                },
              }}
              disabled={isTopupLoading}
            >
              {isTopupLoading ? (
                <CircularProgress size={20} />
              ) : (
                <Box
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  Top-up Balance
                </Box>
              )}
            </Button>
          </Box>
        )}

        <Box
          mt="40px"
          sx={{
            margin: "auto",
            width: "98%",
          }}
        >
          <TableDatagrid
            data={transactionsData}
            columns={columns}
            fontSize="13px"
          />
        </Box>
      </Box>
      <SnackbarComp
        open={openSnackbar}
        onClose={handleCloseSnackbar}
        errorMessage={error}
        statusCode={statusCode}
      />
    </>
  );
};

export default PaymentsHistory;
